import React, { useEffect, useState } from "react";
import axios from "axios";
import progressGif from "../../images/progress.gif";
import { exportToExcelSheet } from "./exportToExcelSheet";
import Pmgkay_Afso from "./Pmgkay_Afso"; 

const Pmgkay_Dist = ({ month, year }) => {
  const [schemes, setSchemes] = useState([]);
  const [loadingSchemes, setLoadingSchemes] = useState(true);
  const [error, setError] = useState(null);
  const [data, setData] = useState([]);
  const [fetchingData, setFetchingData] = useState(false);
  const [fetchError, setFetchError] = useState("");
  const [refreshTime, setRefreshTime] = useState("");
  const [selectedDistCode, setSelectedDistCode] = useState("");

  const getMonthName = (monthNumber) => {
    const monthNames = [
      "January", "February", "March", "April", "May", "June",
      "July", "August", "September", "October", "November", "December"
    ];
    return monthNames[monthNumber - 1] || "";
  };

  const formatRefreshTime = (date) => {
    const now = date || new Date();
    return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2,'0')}-${String(now.getDate()).padStart(2,'0')} ${String(now.getHours()).padStart(2,'0')}:${String(now.getMinutes()).padStart(2,'0')}:${String(now.getSeconds()).padStart(2,'0')}`;
  };

  useEffect(() => {
    axios
      .get(`${process.env.REACT_APP_URL_SIDE}/api/pmgkay/schemes`)
      .then((res) => {
        setSchemes(res.data);
        setLoadingSchemes(false);
      })
      .catch((err) => {
        console.error(err);
        setError("Failed to fetch schemes.");
        setLoadingSchemes(false);
      });
  }, []);

  useEffect(() => {
    if (!loadingSchemes && schemes.length > 0 && month && year) {
      fetchSummary();
    }
  }, [month, year, loadingSchemes, schemes]);

  const fetchSummary = async () => {
    setFetchingData(true);
    setFetchError("");
    setData([]);

    try {
      const schemeIds = schemes.map((s) => s.schemeId.toString());
      const response = await axios.post(
        `${process.env.REACT_APP_URL_SIDE}/api/pmgkay/pmgkaySummary?month=${month}&year=${year}`,
        schemeIds,
        { headers: { "Content-Type": "application/json" } }
      );

      if (!response.data || response.data.length === 0) {
        setFetchError("No Transaction Details Found");
      } else {
        setData(response.data);
        setRefreshTime(formatRefreshTime()); 
      }
    } catch (err) {
      console.error(err);
      setFetchError("Error fetching summary data.");
    } finally {
      setFetchingData(false);
    }
  };

  const headerStyle = {
    backgroundColor: "black",
    color: "white",
    textAlign: "center",
    padding: "3px 5px",
    fontSize: "14px",
  };

  const cellStyle = {
    padding: "3px 5px",
    textAlign: "center",
    fontSize: "14px",
  };

  const totals = {};
  if (data.length > 0) {
    totals.totalCards = data.reduce((sum, row) => sum + (row.totalCards || 0), 0);
    totals.availPmgkayCards = data.reduce((sum, row) => sum + (row.availPmgkayCards || 0), 0);
    totals.pmgkaySale = data.reduce((sum, row) => sum + (row.pmgkaySale || 0), 0);
    totals.pmgkayWheatSale = data.reduce((sum, row) => sum + (row.pmgkayWheatSale || 0), 0);

    schemes.forEach((scheme) => {
      totals["scheme_" + scheme.schemeId] = data.reduce(
        (sum, row) => sum + (row.dynamicFields?.["scheme_" + scheme.schemeId] || 0),
        0
      );
      totals["rice_" + scheme.schemeId] = data.reduce(
        (sum, row) => sum + (row.dynamicFields?.["rice_" + scheme.schemeId] || 0),
        0
      );
      totals["wheat_" + scheme.schemeId] = data.reduce(
        (sum, row) => sum + (row.dynamicFields?.["wheat_" + scheme.schemeId] || 0),
        0
      );
    });
  }


  return (
    <div style={{ margin: "20px" }}>
      {fetchingData && (
        <div style={{ textAlign: "center", marginTop: "20px" }}>
          <img src={progressGif} alt="Loading..." width="250" height="15" />
        </div>
      )}

      {!fetchingData && fetchError && (
        <div style={{ textAlign: "center", marginTop: "20px", color: "red", fontWeight: "bold", fontSize: "16px" }}>
          {fetchError}
        </div>
      )}

      {!fetchingData && data.length > 0 && (
        <>
          <table
            border="1"
            cellPadding="3"
            style={{ borderCollapse: "collapse", width: "70%", margin: "20px auto", fontSize: "14px" }}
          >
            <thead>
              <tr>
                <th colSpan={3 + schemes.length * 3 + 4} style={{
                  backgroundColor: "black",
                  color: "white",
                  textAlign: "center",
                  fontSize: "18px",
                  fontWeight: "bold",
                  padding: "5px"
                }}>
                  PMGKAY Details for {getMonthName(Number(month))} '{year}
                </th>
              </tr>
              <tr>
                <th rowSpan="3" style={headerStyle}>Sl.No</th>
                <th rowSpan="3" style={headerStyle}>District</th>
                <th rowSpan="3" style={headerStyle}>Total Cards</th>
                <th colSpan={schemes.length * 3 + 4} style={headerStyle}>Availed</th>
              </tr>
              <tr>
                {schemes.map((scheme) => (
                  <th key={scheme.schemeId} colSpan="3" style={headerStyle}>{scheme.schemeDesc}</th>
                ))}
                <th colSpan="4" style={headerStyle}>Total</th>
              </tr>
              <tr>
                {schemes.map((scheme) => (
                  <React.Fragment key={scheme.schemeId}>
                    <th style={headerStyle}>Cards</th>
                    <th style={headerStyle}>Rice Sale<br /> (in Kgs)</th>
                    <th style={headerStyle}>Wheat Sale<br /> (in Kgs)</th>
                  </React.Fragment>
                ))}
                <th style={headerStyle}>Cards</th>
                <th style={headerStyle}>Availed %</th>
                <th style={headerStyle}>Rice Sale<br /> (in Kgs)</th>
                <th style={headerStyle}>Wheat Sale<br /> (in Kgs)</th>
              </tr>
            </thead>
            <tbody>
              {data.map((row, idx) => (
                <tr key={idx}>
                  <td style={cellStyle}>{idx + 1}</td>
                  <td style={cellStyle}>
                    <span
                      style={{
                        color: "black",
                        textDecoration: "underline",
                        cursor: "pointer"
                      }}
                      onClick={() => setSelectedDistCode(row.distCode)}
                      onMouseEnter={(e) => (e.target.style.color = "red")}
                      onMouseLeave={(e) => (e.target.style.color = "black")}
                    >
                      {row.distName || "-"}
                    </span>
                  </td>
                  <td style={cellStyle}>{row.totalCards || 0}</td>
                  {schemes.map((scheme) => (
                    <React.Fragment key={scheme.schemeId}>
                      <td style={cellStyle}>{row.dynamicFields?.["scheme_" + scheme.schemeId] || 0}</td>
                      <td style={cellStyle}>{(row.dynamicFields?.["rice_" + scheme.schemeId] || 0).toFixed(3)}</td>
                      <td style={cellStyle}>{(row.dynamicFields?.["wheat_" + scheme.schemeId] || 0).toFixed(3)}</td>
                    </React.Fragment>
                  ))}
                  <td style={cellStyle}>{row.availPmgkayCards || 0}</td>
                  <td style={cellStyle}>
                    {row.totalCards
                      ? ((row.availPmgkayCards / row.totalCards) * 100).toFixed(2)
                      : "0.00"}
                  </td>
                  <td style={cellStyle}>{(row.pmgkaySale || 0).toFixed(3)}</td>
                  <td style={cellStyle}>{(row.pmgkayWheatSale || 0).toFixed(3)}</td>
                </tr>
              ))}

              <tr style={{ fontWeight: "bold", backgroundColor: "black", color: "white" }}>
                <td colSpan="2" style={{ textAlign: "center", padding: "3px 5px" }}>Total</td>
                <td style={cellStyle}>{totals.totalCards || 0}</td>
                {schemes.map((scheme) => (
                  <React.Fragment key={scheme.schemeId}>
                    <td style={cellStyle}>{totals["scheme_" + scheme.schemeId] || 0}</td>
                    <td style={cellStyle}>{(totals["rice_" + scheme.schemeId] || 0).toFixed(3)}</td>
                    <td style={cellStyle}>{(totals["wheat_" + scheme.schemeId] || 0).toFixed(3)}</td>
                  </React.Fragment>
                ))}
                <td style={cellStyle}>{totals.availPmgkayCards || 0}</td>
                <td style={cellStyle}>
                  {totals.totalCards
                    ? ((totals.availPmgkayCards / totals.totalCards) * 100).toFixed(2)
                    : "0.00"}
                </td>
                <td style={cellStyle}>{(totals.pmgkaySale || 0).toFixed(3)}</td>
                <td style={cellStyle}>{(totals.pmgkayWheatSale || 0).toFixed(3)}</td>
              </tr>

              <tr style={{ backgroundColor: "white", color: "black" }}>
                <td colSpan={3 + schemes.length * 3 + 4} style={{ textAlign: "right", padding: "5px" }}>
                  Refresh Time: {refreshTime || formatRefreshTime()}
                </td>
              </tr>
            </tbody>
          </table>

      <div style={{ textAlign: "center", marginTop: "px",marginBottom:"5px" }}>
            <button
              onClick={() => exportToExcelSheet(data, schemes, totals, month, year, refreshTime)}
              style={{
            padding: "6px 20px",
            fontSize: "14px",
            backgroundColor: "black",
            color: "white",
            border: "none",
            borderRadius: "20px",
            cursor: "pointer"
          }}
        >
          Data to Excel
        </button>
          </div>

          <Pmgkay_Afso
            distCode={selectedDistCode}
            distName={data.find(d => d.distCode === selectedDistCode)?.distName || selectedDistCode}
            month={month}
            year={year}
            singleRowOnly={false}
          />
        </>
      )}
    </div>
  );
};

export default Pmgkay_Dist;
